import { Address } from '@app/model/implementation/Address';
import { FederalInfo } from '@app/model/implementation/FederalInfo';
import { StateWithholding } from '@app/model/implementation/StateWithholding';
import { IPersonalInformation } from '@app/model/interfaces/IPersonalInformation';
import { IServicePersonalInformation } from '@app/model/interfaces/IServicePersonalInformation';

export class PersonalInformation implements IPersonalInformation {
  address: Address;
  childrenUnder17: number;
  employeeId: string;
  exemptFromWithholding: boolean;
  federalInfo: FederalInfo;
  firstName: string;
  id: number;
  lastName: string;
  otherDependents: number;
  ssn: string;
  stateWithholding: StateWithholding;

  constructor(serviceInfo: IServicePersonalInformation) {
    this.id = serviceInfo.id;
    this.employeeId = serviceInfo.employeeId;
    this.firstName = serviceInfo.firstName;
    this.lastName = serviceInfo.lastName;
    this.ssn = serviceInfo.ssn;
    this.address = new Address(serviceInfo);
    this.federalInfo = new FederalInfo(serviceInfo);
    this.stateWithholding = new StateWithholding(serviceInfo);
  }

  public isValid() {
    return (
      this.firstName &&
      this.lastName &&
      this.address.isValid() &&
      ((!this.federalInfo.isExempt && this.federalInfo.withHoldingStatus !== '') ||
        this.federalInfo.isExempt)
    );
  }

  public toJson(): IServicePersonalInformation {
    return {
      address: this.address.line1,
      address2: this.address.line2,
      city: this.address.city,
      employeeId: this.employeeId,
      federalWithholding: this.federalInfo.withHoldingStatus,
      federal_allowances: this.federalInfo.allowances,
      federalAdditionallWithholdingAmount: this.federalInfo.aditionallWithholdingAmount,
      federalExempt: this.federalInfo.isExempt,
      federalTwoJobsTotal: this.federalInfo.twoJobsTotal,
      federalQualifiedChildrenCount: this.federalInfo.qualifiedChildrenCount,
      federalQualifiedChildrenAmount: this.federalInfo.qualifiedChildrenAmount,
      federalOtherDependentsCount: this.federalInfo.otherDependentsCount,
      federalOtherDependentsAmount: this.federalInfo.otherDependentsAmount,
      federalTotalClaimAmount: this.federalInfo.totalClaimAmount,
      federalOtherIncomeAmount: this.federalInfo.otherIncomeAmount,
      federalDeductionsAmount: this.federalInfo.deductionsAmount,
      firstName: this.firstName,
      id: this.id,
      lastName: this.lastName,
      ssn: this.ssn,
      state: this.address.state,
      stateWithholding: this.stateWithholding.stateWithholding,
      stateDependents: this.stateWithholding.stateDependents,
      stateAdditionallWithholdingAmount: this.stateWithholding.stateAdditionallWithholdingAmount,
      zip: '' + this.address.zip,
      alternateCalculationCode: this.stateWithholding.alternateCalculationCode,
    };
  }
}
